// @module MHI.QuantityAvailable.QtyAvailable
define('MHI.QuantityAvailable.QtyAvailable.View'
,	[
	'mhi_quantityavailable_qtyavailable.tpl'
	
	//,	'MHI.QuantityAvailable.QtyAvailable.Model'
	
	,	'Backbone'
//	,	'AjaxRequestsKiller'
    ]
, function (
	mhi_quantityavailable_qtyavailable_tpl
	
//	,	QtyAvailableModel
	
	,	Backbone
	//,	AjaxRequestsKiller
)
{
    'use strict';

	// @class MHI.QuantityAvailable.QtyAvailable.View @extends Backbone.View
	return Backbone.View.extend({

		template: mhi_quantityavailable_qtyavailable_tpl

	,	initialize: function (options) {

			this.options = options || {};
			this.container = this.options.container;
			
			this.pdp = this.container.getComponent("PDP");
			
			var stockinfo = this.pdp.getStockInfo();
			var itemInfo = this.pdp.getItemInfo();
			this.qtyavail = stockinfo.stock;
			
			
			this.itemType = this.pdp.getItemInfo().item.itemtype;
			
			if(this.itemType == "Assembly" || this.itemType == "Kit"){
				this.qtyassembly = Number(itemInfo.item.custitem_dhi_qty_avail_build_stored) + Number(this.qtyavail);
				//this.model = new QtyAvailableModel();
				//var self = this;
				// this.model.fetch({
				// data:{
				// 	internalid:internalid
				// },
				// killerId: AjaxRequestsKiller.getKillerId(),
				// pageGeneratorPreload:true
			
				// }).done(function(result){
				// 	self.qtyassembly = Number(result.value) + Number(self.qtyavail);
				// 	self.render();
				// })
			}
			
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return MHI.QuantityAvailable.QtyAvailable.View.Context
	,	getContext: function getContext()
		{
			//@class MHI.QuantityAvailable.QtyAvailable.View.Context
			return {
				qtyavail:this.qtyavail,
				qtyassembly:this.qtyassembly,
				isAssembly: this.itemType == "Assembly" || this.itemType == "Kit"
			};
		}
	});
});
